function SvgWifi(props) {
  return (
    <svg viewBox="0 0 29 22" width="1em" height="1em" {...props}>
      <g>
        <path d="M19.26 14.531a8.091 8.091 0 00-9.57 0 .834.834 0 00-.103 1.258.82.82 0 001.075.073 6.402 6.402 0 017.625 0 .842.842 0 00.5.166c.21 0 .417-.08.575-.24a.825.825 0 00.237-.647.836.836 0 00-.34-.61M5.243 10.163a.807.807 0 00-.287.59.836.836 0 00.243.625.813.813 0 001.104.048c4.659-3.938 11.684-3.938 16.343 0a.81.81 0 001.104-.048l-.044-.044.046.041a.834.834 0 00.241-.623.807.807 0 00-.287-.589c-5.263-4.452-13.2-4.452-18.463 0m9.232 8.777a1.45 1.45 0 00-1.445 1.452c0 .8.648 1.452 1.445 1.452a1.45 1.45 0 001.444-1.452c0-.8-.648-1.451-1.444-1.451" />
        <path d="M28.674 5.448A21.187 21.187 0 0014.474 0a21.187 21.187 0 00-14.2 5.448.823.823 0 00-.274.595.821.821 0 00.243.61.815.815 0 001.123.032 19.55 19.55 0 0113.109-5.033 19.55 19.55 0 0113.108 5.033.815.815 0 001.125-.035.82.82 0 00.24-.607.823.823 0 00-.274-.595" />
      </g>
    </svg>
  );
}

export default SvgWifi;
